function formatter(format: 'decimal' | 'currency' | 'percent', value = 0) {
  let options;
  const finalValue = format === 'percent' ? value / 100 : value;

  switch (format) {
    case 'currency':
      options = { style: format, currency: 'IDR', maximumFractionDigits: 0 };
      break;
    case 'percent':
      options = { style: format, minimumFractionDigits: 2, maximumFractionDigits: 2 };
      break;
    default:
      options = { style: format };
  }

  return new Intl.NumberFormat('in-ID', options).format(finalValue);
}

export { formatter };
